export const runtimesToSelectOptions = (arr: string[]) => {
    return arr?.length > 0
        ? arr.map((item) => {
              const minutes = parseInt(item, 10);
              const hrs = Math.floor(minutes / 60);
              const mins = minutes % 60;

              let label;
              if (hrs > 0 && mins > 0) {
                  label = `${hrs}h ${mins}m`;
              } else if (hrs > 0) {
                  label = `${hrs}h`;
              } else {
                  label = `${mins}m`;
              }

              return { id: item, label };
          })
        : [];
};

export const arrayToSelectOptions = (arr) => {
    return arr && arr.length > 0
        ? arr.map((item) => {
              return { id: item, label: item };
          })
        : [];
};

export const selectOptionsToArray = (options) => {
    return options && options.length > 0 ? options.map((op) => op.id) : [];
};
